"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Rgb(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M20 4c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V6c0-1.103.897-2 2-2zm0 2H4v12h16.002L20 6zm-8.004 3.441c.62 0 1.102.143 1.444.426.343.284.543.707.6 1.27h-1.155c-.041-.278-.13-.476-.266-.594-.137-.119-.331-.178-.582-.178a.78.78 0 0 0-.697.383c-.164.255-.247.619-.25 1.094v.301c0 .496.086.869.256 1.119.17.249.436.374.8.374.313 0 .545-.07.698-.208v-.774h-.834v-.823h2.034v2.044c-.185.205-.454.37-.81.496a3.504 3.504 0 0 1-1.17.188c-.651 0-1.171-.2-1.561-.598-.39-.399-.6-.954-.626-1.665l-.003-.431c0-.49.087-.918.26-1.283.173-.366.42-.647.743-.845a2.101 2.101 0 0 1 1.119-.296zm-4.635.073c.591 0 1.053.13 1.385.393.333.26.5.63.5 1.109 0 .347-.072.633-.21.86-.141.229-.36.412-.66.554l1.04 2.009v.052H8.13l-.879-1.76h-.647v1.76h-1.2V9.514h1.958zm9.168 0c.64 0 1.127.117 1.461.351.334.236.5.576.5 1.023 0 .258-.059.477-.178.659a1.037 1.037 0 0 1-.522.404c.26.069.46.195.598.383.14.187.208.414.208.684 0 .487-.154.853-.463 1.098-.308.245-.766.369-1.372.374h-2.02V9.514h1.788zm.252 2.861h-.84v1.192h.785c.217 0 .383-.049.5-.148A.526.526 0 0 0 17.4 13c0-.415-.206-.623-.619-.625zm-9.42-1.938h-.757v1.37h.758c.228 0 .399-.06.513-.18.117-.12.174-.287.174-.502 0-.214-.058-.382-.174-.505-.117-.122-.287-.183-.513-.183zm9.168 0h-.588v1.151h.625c.262-.002.45-.05.561-.144.111-.093.168-.231.168-.415 0-.21-.06-.361-.182-.454-.12-.093-.316-.138-.584-.138z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Rgb;
